<cx-view class="card">
  @if (form$ | async; as form) {
    <form [formGroup]="form" (submit)="save(form)">
      <div class="header">
        <div class="title-bar">
          <div class="title">
            <h3>
              {{ "units.details" | cxTranslate }}
            </h3>
          </div>
          <div class="actions">
            <button class="btn btn-secondary" type="submit">
              {{ "units.buttons.save" | cxTranslate }}
            </button>
            <a
              class="link edit"
              routerLink="../"
              [class.disabled]="isInEditMode$ | async"
              >
              {{ "units.buttons.cancel" | cxTranslate }}
            </a>
          </div>
        </div>
      </div>
      <div class="main">
        <section main class="details">
          <div class="property">
            <label>{{ "orgUnit.name" | cxTranslate }}</label>
            <span class="value">
              {{ form.value.name }}
            </span>
          </div>
          <div class="property">
            <label>{{ "orgUnit.uid" | cxTranslate }}</label>
            <span class="value">
              {{ form.value.uid }}
            </span>
          </div>
          <div class="property">
            <label>{{ "orgUnit.active" | cxTranslate }}</label>
            <span class="value" [class.is-active]="form.value.active">
              {{
              (form.value.active
              ? "organization.enabled"
              : "organization.disabled"
              ) | cxTranslate
              }}
            </span>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>{{ "units.days" | cxTranslate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="config-days-title">
                  {{ "units.configEKPriceChangeDays" | cxTranslate }}
                </td>
                <td>
                  <input
                    class="form-control"
                    type="number"
                    min="0"
                    oninput="validity.valid||(value='');"
                    formControlName="configEKPriceChangeDays"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="config-days-title">
                    {{ "units.configProductCreationDays" | cxTranslate }}
                  </td>
                  <td>
                    <input
                      class="form-control"
                      type="number"
                      min="0"
                      oninput="validity.valid||(value='');"
                      formControlName="configProductCreationDays"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
          </div>
        </form>
      }
    </cx-view>
